import React from "react";
import { useLang } from "../i18n";

export function AiDisclaimer({ className = "mt-8" }) {
  const { t } = useLang();
  return <p className={`text-sm text-[#6E6B65] ${className}`} data-testid="ai-disclaimer">{t("ai_disclaimer")}</p>;
}
